/**
 * Enum for Machine Group Type.
 * @readonly
 * @enum {String} MachineGroupTypeEnum
 */

const MachineGroupTypeEnum = {
  PRINT: 'print',
  VOIP : 'voip'
}

export default MachineGroupTypeEnum
